export default {"src":"/_next/static/media/lhc-logo-full-2024.b3931f5c.svg","height":408,"width":1723,"blurWidth":0,"blurHeight":0};